import React from 'react';
import classes from './product-list.module.scss';
import Card from '../card/card';

const ProductList = ({ products }: { products: any[] }) => {
  return (
    <div className={classes.categoryList}>
      {products.map((product: any) => (
        <Card key={product.id} card={product} />
      ))}
      {/* <a className={classes.showMore}>Більше пропозицій</a> */}
    </div>
  );
};

export default ProductList;
